// extracted by mini-css-extract-plugin
export var actionCell = "TeamDetailPage-module__actionCell___H-tGh";
export var actions = "TeamDetailPage-module__actions___OFcj7";
export var addButton = "TeamDetailPage-module__addButton___5yjpL";
export var assignManagerLink = "TeamDetailPage-module__assignManagerLink___ClS4X";
export var backLink = "TeamDetailPage-module__backLink___KTYtI";
export var cancelButton = "TeamDetailPage-module__cancelButton___o5BuS";
export var card = "TeamDetailPage-module__card___0CEGx";
export var closeButton = "TeamDetailPage-module__closeButton___JXI7-";
export var colAction = "TeamDetailPage-module__colAction___APhvy";
export var colAdded = "TeamDetailPage-module__colAdded___mEoJG";
export var colDate = "TeamDetailPage-module__colDate___GSrs4";
export var colEmail = "TeamDetailPage-module__colEmail___QUw9H";
export var colName = "TeamDetailPage-module__colName___rFro8";
export var colRole = "TeamDetailPage-module__colRole___2A7b+";
export var colStatus = "TeamDetailPage-module__colStatus___Rjn9f";
export var defaultBadge = "TeamDetailPage-module__defaultBadge___35RIU";
export var emptyHint = "TeamDetailPage-module__emptyHint___tB4Yg";
export var emptyMessage = "TeamDetailPage-module__emptyMessage___QzBpo";
export var errorMessage = "TeamDetailPage-module__errorMessage___sD6aJ";
export var exampleFormatChip = "TeamDetailPage-module__exampleFormatChip___ahkRc";
export var exampleFormats = "TeamDetailPage-module__exampleFormats___EFZOT";
export var exampleFormatsLabel = "TeamDetailPage-module__exampleFormatsLabel___WWC78";
export var fieldError = "TeamDetailPage-module__fieldError___pl1Cy";
export var fieldHint = "TeamDetailPage-module__fieldHint___Xfc2B";
export var fieldLabel = "TeamDetailPage-module__fieldLabel___4GVqK";
export var headerLeft = "TeamDetailPage-module__headerLeft___ZuvrV";
export var headerRow = "TeamDetailPage-module__headerRow___g+gra";
export var inactiveBanner = "TeamDetailPage-module__inactiveBanner___-GbXk";
export var inactiveBannerActivate = "TeamDetailPage-module__inactiveBannerActivate___5WRa1";
export var inactiveBannerText = "TeamDetailPage-module__inactiveBannerText___kVaxt";
export var infoCallout = "TeamDetailPage-module__infoCallout___gqLh8";
export var inputError = "TeamDetailPage-module__inputError___FK+PW";
export var invitationsHeader = "TeamDetailPage-module__invitationsHeader___3Hc+-";
export var invitationsSection = "TeamDetailPage-module__invitationsSection___ndD7h";
export var invitationsTitle = "TeamDetailPage-module__invitationsTitle___NG0br";
export var inviteFormGroup = "TeamDetailPage-module__inviteFormGroup___J8VLI";
export var inviteHint = "TeamDetailPage-module__inviteHint___QONBz";
export var inviteInfoCallout = "TeamDetailPage-module__inviteInfoCallout___rVy4x";
export var inviteLabel = "TeamDetailPage-module__inviteLabel___EGrTl";
export var memberCheckbox = "TeamDetailPage-module__memberCheckbox___LgzWe";
export var memberEmail = "TeamDetailPage-module__memberEmail___K4ZbJ";
export var memberInfo = "TeamDetailPage-module__memberInfo___DRRR4";
export var memberList = "TeamDetailPage-module__memberList___5rFFO";
export var memberListSpinner = "TeamDetailPage-module__memberListSpinner___Ob4Ee";
export var memberName = "TeamDetailPage-module__memberName___CbyrY";
export var memberRow = "TeamDetailPage-module__memberRow___2SKe5";
export var membersHeader = "TeamDetailPage-module__membersHeader___mPq+H";
export var membersSection = "TeamDetailPage-module__membersSection___YNwem";
export var membersTitle = "TeamDetailPage-module__membersTitle___bzkYa";
export var metaRow = "TeamDetailPage-module__metaRow___D+SAv";
export var modal = "TeamDetailPage-module__modal___psY0u";
export var modalBody = "TeamDetailPage-module__modalBody___ND8Lq";
export var modalFooter = "TeamDetailPage-module__modalFooter___aKc68";
export var modalHeader = "TeamDetailPage-module__modalHeader___b8L2A";
export var modalSmall = "TeamDetailPage-module__modalSmall___pJLyO";
export var modalTitle = "TeamDetailPage-module__modalTitle___1emWW";
export var nameInput = "TeamDetailPage-module__nameInput___zu3pL";
export var overflowButton = "TeamDetailPage-module__overflowButton___ei1vQ";
export var overflowMenu = "TeamDetailPage-module__overflowMenu___s8O1D";
export var overflowMenuContainer = "TeamDetailPage-module__overflowMenuContainer___G5pz5";
export var overflowMenuItem = "TeamDetailPage-module__overflowMenuItem___IdZ80";
export var overlay = "TeamDetailPage-module__overlay___TvQaB";
export var page = "TeamDetailPage-module__page___2q0Ku";
export var removeLink = "TeamDetailPage-module__removeLink___b-jUO";
export var renameButton = "TeamDetailPage-module__renameButton___tr6Ob";
export var required = "TeamDetailPage-module__required___J6v+X";
export var roleBadge = "TeamDetailPage-module__roleBadge___NOw51";
export var searchInput = "TeamDetailPage-module__searchInput___GOro+";
export var selectAllRow = "TeamDetailPage-module__selectAllRow___G3swD";
export var sendInviteButton = "TeamDetailPage-module__sendInviteButton___MBZ3b";
export var spinnerContainer = "TeamDetailPage-module__spinnerContainer___3ibCP";
export var statusAction = "TeamDetailPage-module__statusAction___nmUgU";
export var statusActive = "TeamDetailPage-module__statusActive___b0wis";
export var statusBadge = "TeamDetailPage-module__statusBadge___NBhQi";
export var statusInactive = "TeamDetailPage-module__statusInactive___wwn7Y";
export var submitButton = "TeamDetailPage-module__submitButton___1kVx8";
export var table = "TeamDetailPage-module__table___0Ailp";
export var tableContainer = "TeamDetailPage-module__tableContainer___fYz66";
export var teamTitle = "TeamDetailPage-module__teamTitle___A53-L";